module.exports = __webpack_public_path__ + "media/images/enabled_procedure_managements/user_examples-8dc62b12eb687c6edf53b9602af77e9c.png";